import { Injectable } from '@angular/core';
import { SortOption } from 'src/app/modules/shared/pipes/sort.pipe';
import { BaseRepository } from './abstract/base.repository';

export interface Position {
    id: string;
    name: string;    
  }

export const positionsSortOptions: SortOption[] = [
  { label: $localize `:Sort label Name:Name`, property: 'name' }  
];

@Injectable({ providedIn: 'root' })
export class PositionsRepository extends BaseRepository<Position> {

  constructor() {
    super('positions', positionsSortOptions);
  }

}